const ACTIONS = {
    SIGN_IN_REQUEST : "SIGN_IN_REQUEST",
    SIGN_IN_SUCCESS : "SIGN_IN_SUCCESS",
    SIGN_IN_FAIL    : "SIGN_IN_FAIL",
    LOGOUT_SUCCESS  : "LOGOUT_SUCCESS",
    LOGOUT_REQUEST  : "LOGOUT_REQUEST",
}

export default ACTIONS;